export default __webpack_public_path__ + "static/media/Frame 222 (1).e1c46a13.svg";